import React, {Fragment, useContext, useEffect, useState} from "react";
import {useHistory, useLocation, useParams} from "react-router-dom";
import { CourseApiCalls } from "../../apis/CourseApiCalls";
import { ResponseApiCalls } from "../../apis/ResponseApiCalls";
import { YuJaTextBox } from "../../components/standardization/YuJaTextBox";
import { useCookie } from "../../hooks/useCookie";
import { useLocalStorageNew } from "../../hooks/useLocalStorageNew";
import {
  AUDIENCE_RESTRICTION,
    POLL_CODE_LENGTH,
    SCREEN_TYPE,
    TEXTBOX,
    VIEWER_USER_TYPE,
} from "../../utils/constants";
import { formatErrorLog, newPageLog, notifyError } from "../../utils/helpers";

import "./styles.css";
import styles from "../LoginPage/Login.module.css";
import { ReactComponent as YuJaLogo } from "../../images/yujalogo.svg";
import {ReactComponent as INVALID_ICON} from "../LoginPage/images/invalid-icon.svg"
import useWindowDimensions from "../../hooks/useWindowDimensions";
import {YuJaTooltip} from "../../components/standardization/YuJaTooltip";
import {Button} from "@base-ui/react/button";
import {YuJaGlobalState} from "../../utils/LoadingContext";
import { useTranslation } from "react-i18next";

export default function GuestLoginPage() {
    const { t } = useTranslation();
  const {pollUniqueCode} = useParams();
  const { setUserNameToLocalStorage, getPollRecordFromUniqueCode} = ResponseApiCalls();
  const { checkMemberAccess } = CourseApiCalls();
  const location = useLocation();
  const [name, setName] = useState("");
  const [setCookie, , ] = useCookie("name", "Guest");
  let history = useHistory();
  let errorRed = "0px 0px 2px 2px #C93E3E";
  const {type, isTouchAble} = useWindowDimensions();
  const {globalHostResource: hostResource} = useContext(YuJaGlobalState);
  const { imageURL } = hostResource;

  const [setWarning, ] = useLocalStorageNew("warning", {});

  const [pollCode, setPollCode] = useState(['', '', '', '', '', '']);
  const [showLoginJoin, setShowLoginJoin] = useState(false);
  const [isProcessing, setIsProcession] = useState(false);
  const [nameError, setNameError] = useState("");
  const [codeError, setCodeError] = useState("");
  const [, getSession] = useLocalStorageNew("session", {});
  const session = getSession();

  const inlineStyles = {
    rowStyle: {display: "flex", alignItems: "center", gap: 5},
    inputBoxStyle: {fontSize: 15, height: 47, fontWeight: "400", padding: 12},
    linkStyle: {textDecoration: "underline", fontSize: 16, alignSelf: "center", fontWeight: "600"},
    buttonGroupStyle: {width: "100%", display: "flex", flexDirection: "column", alignItems: "center", gap: 15}
  }

  useEffect(() => {
    newPageLog("GuestLoginPage.js");
  }, [])

  const checkAuthorization = async (pollUniqueCode) => {
    const result = await getPollRecordFromUniqueCode(pollUniqueCode);
    if (!result || !result.poll) {
      setCodeError(t("auth.invalidCode"));
      formatErrorLog(t("poll.invalidActivityCode"));
      return;
    }

    const { index2Pk: courseId, lmsHomeUrl, syncLms = true, audienceRestriction = null } = result.poll;
    if ((audienceRestriction && audienceRestriction === AUDIENCE_RESTRICTION.UNRESTRICTED && !session.authorization) || location?.state?.reauthenticate) {
      console.log("audienceRestriction is UNRESTRICTED, no anything required.")
      return;
    }

    if (audienceRestriction === AUDIENCE_RESTRICTION.NAME_REQUIRED && !session.authorization && !name) {
      console.log("audienceRestriction is NAME_REQUIRED, name required.")
      return;
    }

    if (audienceRestriction === AUDIENCE_RESTRICTION.LOGGED_IN || audienceRestriction === AUDIENCE_RESTRICTION.REGISTERED) {

      if (!session.authorization) {
        notifyError(t("poll.disableGuestWarning"));
        return;
      }

      if (audienceRestriction === AUDIENCE_RESTRICTION.REGISTERED && !!courseId) {
        if (!(await checkUserAccess(courseId))) {
          return;
        }

        if (!!lmsHomeUrl) {
          if (!!session.gradedLink || !syncLms) {
            setWarning(false);
            setUserNameToLocalStorage(pollUniqueCode, session.userId, VIEWER_USER_TYPE.LOGGED_IN);
            history.push(`/join/${pollUniqueCode}`);
            return;
          } else {// if it's a LMS embedded poll and current user is not LMS user then redirect to guide page
            formatErrorLog(t("integration.embeddedPollGuideRedirectLogMessage"));
            history.push(`/lti/${pollUniqueCode}/guide`);
            return;
          }
        }

      }
    }

    if (session.authorization && session.userId) {
      // if (await checkUserAccess(courseId)) {
        setWarning(false);
        setUserNameToLocalStorage(pollUniqueCode, session.userId, VIEWER_USER_TYPE.LOGGED_IN);
        history.push(`/join/${pollUniqueCode}`);
      // }
    }
  }

  const checkUserAccess = async (courseId) => {
    if (courseId == null) {
        return true;
    }

    const accessibleResult = await checkMemberAccess(courseId.substring(2));
    if (accessibleResult == null || accessibleResult.result == null || !accessibleResult.result) {
        notifyError(t("poll.accessDeniedError"));
        formatErrorLog("User cannot access the poll");
        return false; 
    }

    return true;
  }

  const validateCode = (code, warning=true) => {
    let returnVal = true;
    if (!code) {
      if (warning) {
        setCodeError(t("auth.invalidCode"));
      }
      returnVal = false;
    } else if (code.length !== POLL_CODE_LENGTH) {
      if (warning) {
        setCodeError(t("auth.invalidCode"));
      }
      returnVal = false;
    }
    if (!returnVal && warning) {
      const codeInputs = document.getElementsByName("guest-login-poll-input");
      for (const element of codeInputs) {
        element.style.boxShadow = errorRed;
      }
    }
    return returnVal;
  };

  const handleClick = (index, event) => {
    setCodeError("");
    let inputValue = event.target.value;

    // Remove non-numeric characters
    inputValue = inputValue.replace(/[^0-9]/g, '');

    // Update the state
    const newPollCode = [...pollCode];
    newPollCode[index] = inputValue;
    setPollCode(newPollCode);
    if (inputValue.trim() === "") {
      return;
    }

    if (document.getElementById(`poll-code-input-${index + 1}`) !== null) {
      document.getElementById("poll-code-input-" + (index + 1)).select();
    }
}

  const handleJoin = async () => {
    let code = "" + document.getElementById("poll-code-input-0").value
        + document.getElementById("poll-code-input-1").value
        + document.getElementById("poll-code-input-2").value
        + document.getElementById("poll-code-input-3").value
        + document.getElementById("poll-code-input-4").value
        + document.getElementById("poll-code-input-5").value;


    if (!validateCode(code)) {
     return;
    }

    try {
      setIsProcession(true);
      const result = await getPollRecordFromUniqueCode(code);
      if (!result || !result.poll) {
        setCodeError(t("auth.invalidCode"));
        formatErrorLog(t("poll.invalidActivityCode"));
        return;
      }

      const {index2Pk: courseId, audienceRestriction = null, anonymousJoin=null} = result.poll;
      if (audienceRestriction === AUDIENCE_RESTRICTION.LOGGED_IN || audienceRestriction === AUDIENCE_RESTRICTION.REGISTERED) {

        if (!session.authorization) {
          formatErrorLog(t("poll.disableGuestWarning"));
          notifyError(t("poll.disableGuestWarning"));
          return;
        }

        if (audienceRestriction === AUDIENCE_RESTRICTION.REGISTERED && !!courseId) {
          let isAccessible = await checkUserAccess(courseId);
          if (!isAccessible) {
            return;
          }
        }

      }

      let nameTrimmed = name.trim();
      if ((audienceRestriction === AUDIENCE_RESTRICTION.NAME_REQUIRED || anonymousJoin === true) && nameTrimmed === "") {
        formatErrorLog(t("poll.disableAnonymousWarning"));
        setNameError(t("auth.invalidName"));
        return;
      }

      if (name) {
        setCookie(name);
        setUserNameToLocalStorage(code, name, VIEWER_USER_TYPE.MANUAL_GUEST);
      } else {
        setUserNameToLocalStorage(code);
      }

      history.push(`/join/${code}`);
    } finally {
      setIsProcession(false);
    }
  };

  const handleScan = async () => {
    history.push(`/scan`);
  };

  const handleName = (event) => {
    setName(event.target.value);
    setNameError("");
  }

  const handleChange = (event) => {
    if (event.keyCode === 13) {
      handleJoin();
      return;
    }
    const index = parseInt(event.target.id.substring("poll-code-input-".length));
    if (event.keyCode === 8) {//backspace
      if (document.getElementById(`poll-code-input-${index - 1}`) !== null) {
        document.getElementById("poll-code-input-" + (index - 1)).select();
      }
      return
    }
  };

  const handlePaste = (index, event) => {
    event.preventDefault();
    let inputValue = event.clipboardData.getData('Text').replace(/[^0-9]/g, '');
    const newPollCode = [...pollCode];
    let i;
    for (i = 0; i < inputValue.length; i++) {
      if (index + i == POLL_CODE_LENGTH) break;
      newPollCode[index + i] = inputValue[i];
    }
    setPollCode(newPollCode);
    document.getElementById("poll-code-input-" + Math.min(index + i, POLL_CODE_LENGTH - 1)).select();
  };

  const loginJoin = async () => {
    let code = "" + document.getElementById("poll-code-input-0").value
        + document.getElementById("poll-code-input-1").value
        + document.getElementById("poll-code-input-2").value
        + document.getElementById("poll-code-input-3").value
        + document.getElementById("poll-code-input-4").value
        + document.getElementById("poll-code-input-5").value; 
    
    if (!validateCode(code)) {
          return;
    }
    const result = await getPollRecordFromUniqueCode(code);
    if (!result || !result.poll) {
      notifyError(t("poll.invalidActivityCode"));
      formatErrorLog(t("poll.invalidActivityCode"));
      return;
    }

    setWarning(false);
    history.push("/", {
      from: `/join/${code}`,
      pollCode: code,
    });
  };

  // const anonJoin = async (pollUniqueCode) => {
  //   setLoading(true);
  //   const result = await getPollRecordFromUniqueCode(pollUniqueCode);
  //   if (!result || !result.poll) {
  //     setLoading(false);
  //     return;
  //   }

  //   const {index2Pk: courseId} = result.poll;
  //   if (!!courseId) {
  //     setLoading(false);
  //     return;
  //   }
  //   setLoading(false);
  // };

  useEffect(() => {
    const code = pollUniqueCode;

    if (!!code) {
      setPollCode(code);
    }
    if (validateCode(code, false)) {
      setShowLoginJoin(true);
      checkAuthorization(code);
    }
  }, []);

  const goHome = () => {
    history.push({pathname: "/"});
  }


  return (
      <>
        <div
            style={{backgroundImage: !!imageURL ? `url(${imageURL})` : undefined}}
            className={!!imageURL ? styles.imageBackground : styles.gradientBackground}
        />
        <div className={`${styles.container} ${type === SCREEN_TYPE.MOBILE ? styles.mobileContainer : ""}`}>
          <div style={{flex: 1}}/>
          <div className={styles.loginCard}>
            <div className={styles.logoContainer}>
              <YuJaLogo/>
              <span className={styles.mediumText}>
                {/*{fillFormatText(WELCOME_TO_PLATFORM_TEXT, {institutionName: institutionName})}*/}
                {t("poll.joinAnonymousText")}
              </span>
              <span className={styles.descriptionText}>
                {!!isTouchAble && !showLoginJoin ? t("poll.joinScanQrDescription") : t("poll.joinDescription")}
              </span>
              {/*<span className={styles.descriptionText}>{SIGN_IN_TO_YOUR_ACCOUNT_TEXT}</span>*/}
            </div>
            <div>
              <div style={inlineStyles.rowStyle}>
                <span className={styles.labelText}>{t("common.nameLabel")}</span>
                <span style={{flex: 1}}/>
                {!!nameError &&
                    <>
                      <INVALID_ICON/>
                      <span className={styles.errorText}>{nameError}</span>
                    </>
                }
              </div>
              <div style={{height: 10}}/>
              <YuJaTextBox
                  containerStyle={inlineStyles.inputBoxStyle}
                  placeholder={t("auth.enterNamePlaceholder")}
                  value={name}
                  isInvalid={!!nameError}
                  onChange={handleName}
                  onKeyUp={(event) => {
                    if (event.key === 'Enter') {
                      event.preventDefault();
                      handleJoin();
                    }
                  }}
              />
            </div>

            <div>
              <div style={inlineStyles.rowStyle}>
                <span className={styles.labelText}>{t("accessibility.activityCode")}</span>
                <span style={{flex: 1}}/>
                {!!codeError &&
                    <>
                      <INVALID_ICON/>
                      <span className={styles.errorText}>{codeError}</span>
                    </>
                }
              </div>

              <div style={{height: 10}}/>
              <div style={{...inlineStyles.rowStyle, gap: 0}}>
                {Array.from(Array(6)).map((_, index) =>
                    <Fragment key={index}>
                      <YuJaTextBox
                          id={`poll-code-input-${index}`}
                          containerStyle={{
                            color: "#2F2F2F",
                            fontSize: 15,
                            maxWidth: 47,
                            height: 47,
                          }}
                          isInvalid={!!codeError}
                          inputAlign={"center"}
                          inputMode="numeric"
                          maxLength="1"
                          useValue={true}
                          value={pollCode[index]}
                          onChange={(e) => {
                            handleClick(index, e)
                          }}
                          onKeyUp={(e) => {
                            handleChange(e)
                          }}
                          onPaste={e => handlePaste(index, e)}
                      />
                      {index !== 5 &&
                          <div style={{flex: 1, minWidth: 5}}/>
                      }
                    </Fragment>
                )}
              </div>
            </div>

            <YuJaTooltip placement={"bottom"} text={t("poll.joinPollText")}>
              <Button
                  className={styles.signInButtonNew}
                  onClick={handleJoin}
                  disabled={!!isProcessing}
                  focusableWhenDisabled={true}
              >
                {t("poll.joinPollText")}
              </Button>
              {/*<div*/}
              {/*    className={`${styles.signInButtonNew} ${!!isProcessing ? styles.loadingText : ""}`}*/}
              {/*    onClick={handleJoin}*/}
              {/*    data-disabled={!!isProcessing}*/}
              {/*>*/}
              {/*  {JOIN_POLL}*/}
              {/*</div>*/}
            </YuJaTooltip>

            {!!isTouchAble && !showLoginJoin &&
                <YuJaTooltip placement={"bottom"} text={t("poll.scanQrCode")}>
                  <div className={styles.scanQRCodeButton} onClick={handleScan}>{t("poll.scanQrCode")}</div>
                </YuJaTooltip>
            }

            {showLoginJoin &&
                <YuJaTooltip placement={"bottom"} text={t("auth.loginAndJoinButton")}>
                  <div className={styles.scanQRCodeButton} onClick={loginJoin}>{t("auth.loginAndJoinButton")}</div>
                </YuJaTooltip>
            }

            {!showLoginJoin &&
                <YuJaTooltip placement={"bottom"} text={t("common.goBack")}>
                  <div
                      className={styles.linkText}
                      onClick={goHome}
                      role={TEXTBOX}
                      style={inlineStyles.linkStyle}
                  >
                    {t("common.goBack")}
                  </div>
                </YuJaTooltip>

            }

          </div>
          <div style={{flex: 1}}/>
        </div>
      </>
  );
}
